var exports = {
  "iE": "ScrollFillerSkeleton.module__wrapper___TzFaSU",
  "hw": "ScrollFillerSkeleton.module__wrapperCompact___TzFaSU",
  "vy": "ScrollFillerSkeleton.module__messageGroup___TzFaSU",
  "Os": "ScrollFillerSkeleton.module__group___TzFaSU",
  "my": "ScrollFillerSkeleton.module__avatar___TzFaSU",
  "rf": "ScrollFillerSkeleton.module__body___TzFaSU",
  "wx": "ScrollFillerSkeleton.module__header___TzFaSU",
  "el": "ScrollFillerSkeleton.module__cozyLeadLine___TzFaSU",
  "B8": "ScrollFillerSkeleton.module__cozyContinuation___TzFaSU",
  "Tw": "ScrollFillerSkeleton.module__cozyContinuationLine___TzFaSU",
  "Xw": "ScrollFillerSkeleton.module__cozyAttachment___TzFaSU",
  "Ov": "ScrollFillerSkeleton.module__compactMessages___TzFaSU",
  "ir": "ScrollFillerSkeleton.module__compactRow___TzFaSU",
  "ce": "ScrollFillerSkeleton.module__compactTimestamp___TzFaSU",
  "Ys": "ScrollFillerSkeleton.module__compactBody___TzFaSU",
  "tQ": "ScrollFillerSkeleton.module__compactAuthorPrefix___TzFaSU",
  "hn": "ScrollFillerSkeleton.module__compactAvatar___TzFaSU",
  "_l": "ScrollFillerSkeleton.module__compactUsername___TzFaSU",
  "Mf": "ScrollFillerSkeleton.module__compactLine___TzFaSU",
  "Zb": "ScrollFillerSkeleton.module__compactAttachment___TzFaSU",
};

module.exports = exports;
